/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const DEFORESTATION_IN_THE_AMAZON_AREA = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": {"areaName": "Area 1",},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.084789748440244,
                            -6.752599946076279
                        ],
                        [
                            -59.743969435940244,
                            -6.752599946076279
                        ],
                        [
                            -59.743969435940244,
                            -7.401302838891061
                        ],
                        [
                            -59.084789748440244,
                            -7.401302838891061
                        ],
                        [
                            -59.084789748440244,
                            -6.752599946076279
                        ]
                    ]
                ]
            },
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 2"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.520700496589015,
                            -6.802651681337134
                        ],
                        [
                            -59.53923992529995,
                            -6.802651681337134
                        ],
                        [
                            -59.53923992529995,
                            -6.817651300875112
                        ],
                        [
                            -59.520700496589015,
                            -6.817651300875112
                        ],
                        [
                            -59.520700496589015,
                            -6.802651681337134
                        ],
                        [
                            -59.520700496589015,
                            -6.802651681337134
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 2"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.55434612647183,
                            -6.932178295846419
                        ],
                        [
                            -59.56670574561245,
                            -6.932178295846419
                        ],
                        [
                            -59.56670574561245,
                            -6.947855431337849
                        ],
                        [
                            -59.55434612647183,
                            -6.947855431337849
                        ],
                        [
                            -59.55434612647183,
                            -6.932178295846419
                        ],
                        [
                            -59.55434612647183,
                            -6.932178295846419
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 2"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.177377742682765,
                            -6.946492222898345
                        ],
                        [
                            -59.20072368994839,
                            -6.946492222898345
                        ],
                        [
                            -59.20072368994839,
                            -6.963532044119671
                        ],
                        [
                            -59.177377742682765,
                            -6.963532044119671
                        ],
                        [
                            -59.177377742682765,
                            -6.946492222898345
                        ],
                        [
                            -59.177377742682765,
                            -6.946492222898345
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 2"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.15677837744839,
                            -7.08074915770446
                        ],
                        [
                            -59.17875103369839,
                            -7.08074915770446
                        ],
                        [
                            -59.17875103369839,
                            -7.103235097600075
                        ],
                        [
                            -59.15677837744839,
                            -7.103235097600075
                        ],
                        [
                            -59.15677837744839,
                            -7.08074915770446
                        ],
                        [
                            -59.15677837744839,
                            -7.08074915770446
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 2"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.18630413428433,
                            -7.185674110056039
                        ],
                        [
                            -59.20965008154995,
                            -7.185674110056039
                        ],
                        [
                            -59.20965008154995,
                            -7.21019854113968
                        ],
                        [
                            -59.18630413428433,
                            -7.21019854113968
                        ],
                        [
                            -59.18630413428433,
                            -7.185674110056039
                        ],
                        [
                            -59.18630413428433,
                            -7.185674110056039
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 2"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.30990032569058,
                            -7.2408522120653585
                        ],
                        [
                            -59.33255962744839,
                            -7.2408522120653585
                        ],
                        [
                            -59.33255962744839,
                            -7.266054781026436
                        ],
                        [
                            -59.30990032569058,
                            -7.266054781026436
                        ],
                        [
                            -59.30990032569058,
                            -7.2408522120653585
                        ],
                        [
                            -59.30990032569058,
                            -7.2408522120653585
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 2"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.4046574057687,
                            -7.279677203107869
                        ],
                        [
                            -59.441049617682765,
                            -7.279677203107869
                        ],
                        [
                            -59.441049617682765,
                            -7.302153294684859
                        ],
                        [
                            -59.4046574057687,
                            -7.302153294684859
                        ],
                        [
                            -59.4046574057687,
                            -7.279677203107869
                        ],
                        [
                            -59.4046574057687,
                            -7.279677203107869
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 2"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.55110251451538,
                            -6.853167086722554
                        ],
                        [
                            -59.56826865221069,
                            -6.853167086722554
                        ],
                        [
                            -59.56826865221069,
                            -6.868846838754936
                        ],
                        [
                            -59.55110251451538,
                            -6.868846838754936
                        ],
                        [
                            -59.55110251451538,
                            -6.853167086722554
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 2"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.16932761217163,
                            -7.3117522091997476
                        ],
                        [
                            -59.18374716783569,
                            -7.3117522091997476
                        ],
                        [
                            -59.18374716783569,
                            -7.327416359173871
                        ],
                        [
                            -59.16932761217163,
                            -7.327416359173871
                        ],
                        [
                            -59.16932761217163,
                            -7.3117522091997476
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 3"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.31058697119839,
                            -6.82174202477081
                        ],
                        [
                            -59.32157329932339,
                            -6.82174202477081
                        ],
                        [
                            -59.32157329932339,
                            -6.829923367725843
                        ],
                        [
                            -59.31058697119839,
                            -6.829923367725843
                        ],
                        [
                            -59.31058697119839,
                            -6.82174202477081
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 3"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.28037456885464,
                            -6.8933240189625735
                        ],
                        [
                            -59.287241023932765,
                            -6.8933240189625735
                        ],
                        [
                            -59.287241023932765,
                            -6.900140789684297
                        ],
                        [
                            -59.28037456885464,
                            -6.900140789684297
                        ],
                        [
                            -59.28037456885464,
                            -6.8933240189625735
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 3"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.5529728354562,
                            -7.222460258981579
                        ],
                        [
                            -59.56601910010464,
                            -7.222460258981579
                        ],
                        [
                            -59.56601910010464,
                            -7.23199692076273
                        ],
                        [
                            -59.5529728354562,
                            -7.23199692076273
                        ],
                        [
                            -59.5529728354562,
                            -7.222460258981579
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 3"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.575632137214015,
                            -7.058262121593054
                        ],
                        [
                            -59.58799175635464,
                            -7.058262121593054
                        ],
                        [
                            -59.58799175635464,
                            -7.067802209969486
                        ],
                        [
                            -59.575632137214015,
                            -7.067802209969486
                        ],
                        [
                            -59.575632137214015,
                            -7.058262121593054
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 3"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.48842815772183,
                            -7.007832678978922
                        ],
                        [
                            -59.4980411948312,
                            -7.007832678978922
                        ],
                        [
                            -59.4980411948312,
                            -7.013284774365811
                        ],
                        [
                            -59.48842815772183,
                            -7.013284774365811
                        ],
                        [
                            -59.48842815772183,
                            -7.007832678978922
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 3"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.21376995459683,
                            -6.87150969422264
                        ],
                        [
                            -59.221323055182765,
                            -6.87150969422264
                        ],
                        [
                            -59.221323055182765,
                            -6.879008481406226
                        ],
                        [
                            -59.21376995459683,
                            -6.879008481406226
                        ],
                        [
                            -59.21376995459683,
                            -6.87150969422264
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 3"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.105966609870265,
                            -6.913774036596062
                        ],
                        [
                            -59.11832622901089,
                            -6.913774036596062
                        ],
                        [
                            -59.11832622901089,
                            -6.920590512595985
                        ],
                        [
                            -59.105966609870265,
                            -6.920590512595985
                        ],
                        [
                            -59.105966609870265,
                            -6.913774036596062
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 3"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.45579924866195,
                            -7.133601675449542
                        ],
                        [
                            -59.46163573547835,
                            -7.133601675449542
                        ],
                        [
                            -59.46163573547835,
                            -7.139903938046169
                        ],
                        [
                            -59.45579924866195,
                            -7.139903938046169
                        ],
                        [
                            -59.45579924866195,
                            -7.133601675449542
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 3"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.440349724736166,
                            -7.049449670878551
                        ],
                        [
                            -59.4475595025682,
                            -7.049449670878551
                        ],
                        [
                            -59.4475595025682,
                            -7.05711597484016
                        ],
                        [
                            -59.440349724736166,
                            -7.05711597484016
                        ],
                        [
                            -59.440349724736166,
                            -7.049449670878551
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {"areaName": "Area 3"},
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.3570939569139,
                            -7.11333164842563
                        ],
                        [
                            -59.364475396122884,
                            -7.11333164842563
                        ],
                        [
                            -59.364475396122884,
                            -7.119123176148045
                        ],
                        [
                            -59.3570939569139,
                            -7.119123176148045
                        ],
                        [
                            -59.3570939569139,
                            -7.11333164842563
                        ]
                    ]
                ]
            }
        }
    ]
};

export default DEFORESTATION_IN_THE_AMAZON_AREA;